import { MakeCall } from './createMakeCall';

const deleteUserDocument =
  (makeCall: MakeCall) => (userId: 'me' | number, docUUID: string) =>
    makeCall<undefined>('DELETE', `/api/v2/user/${userId}/document/${docUUID}`);
export { deleteUserDocument };
